module.exports = __webpack_public_path__ + "static/media/maintainspace.cbef958f.png";